export default "__VITE_ASSET__BSZ7wapV__"